import { LOCAL_STORAGE_KEYS } from '@/utils/constants'
import { TrackEventParams } from '@datapunt/matomo-tracker-react/lib/types'
import { NextRouter } from 'next/router'

export function SSOCulturaLogout(
  idToken: string,
  trackingFunction: (params: TrackEventParams) => void,
  routingFunction: NextRouter
) {
  const env = process.env.ENV
  const culturaRedirectUrl = process.env.SSO_REDIRECT_URL
  if (env === 'dev') {
    trackingFunction({
      category: 'User Information',
      action: `User logged out on Cultura PP`,
    })
    localStorage.removeItem(LOCAL_STORAGE_KEYS.TOKEN)
    localStorage.removeItem(LOCAL_STORAGE_KEYS.USER_TYPE)
    return routingFunction.push(
      `https://connect-preprod.cultura.com/oauth2/ausqji2d6RIPsk8wC0x6/v1/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${culturaRedirectUrl}`
    )
  }
  // TODO : fix the ENV variable for CulturaProd from dev to prod on CleverCloud
  if (env === 'prod') {
    trackingFunction({
      category: 'User Information',
      action: `User logged out on Cultura Prod`,
    })
    localStorage.removeItem(LOCAL_STORAGE_KEYS.TOKEN)
    localStorage.removeItem(LOCAL_STORAGE_KEYS.USER_TYPE)
    return routingFunction.push(
      `https://connect.cultura.com/oauth2/auspOslggmgGzzfjd416/v1/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${culturaRedirectUrl}`
    )
  }
  return
}

export function SSODecathlonLogout(
  idToken: string,
  trackingFunction: (params: TrackEventParams) => void,
  routingFunction: NextRouter
) {
  const env = process.env.ENV
  const decathlonRedirectUrl = process.env.SSO_REDIRECT_URL
  if (env === 'dev') {
    trackingFunction({
      category: 'User Information',
      action: `User logged out on Decathlon PP`,
    })
    localStorage.removeItem(LOCAL_STORAGE_KEYS.TOKEN)
    localStorage.removeItem(LOCAL_STORAGE_KEYS.USER_TYPE)
    return routingFunction.push(
      `https://api-global.preprod.decathlon.net/connect/openid/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${decathlonRedirectUrl}`
    )
  }
  // TODO : fix the ENV variable for CulturaProd from dev to prod on CleverCloud
  if (env === 'prod') {
    trackingFunction({
      category: 'User Information',
      action: `User logged out on Decathlon Prod`,
    })
    localStorage.removeItem(LOCAL_STORAGE_KEYS.TOKEN)
    localStorage.removeItem(LOCAL_STORAGE_KEYS.USER_TYPE)
    return routingFunction.push(
      `https://api-global.decathlon.net/connect/openid/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${decathlonRedirectUrl}`
    )
  }
  return
}

export function SSOVirginLogout(
  idToken: string,
  trackingFunction: (params: TrackEventParams) => void,
  routingFunction: NextRouter,
  emptyCart: () => void
) {
  const ssoState = localStorage.getItem(LOCAL_STORAGE_KEYS.SSO_STATE)
  localStorage.removeItem(LOCAL_STORAGE_KEYS.TOKEN)
  localStorage.removeItem(LOCAL_STORAGE_KEYS.REFRESH_TOKEN)
  localStorage.removeItem(LOCAL_STORAGE_KEYS.TOKEN_EXPIRE_AT)
  localStorage.removeItem(LOCAL_STORAGE_KEYS.LOGIN_METHOD)
  localStorage.removeItem(LOCAL_STORAGE_KEYS.SSO_STATE)
  localStorage.removeItem(LOCAL_STORAGE_KEYS.USER_TYPE)
  localStorage.removeItem('CartToken')
  localStorage.removeItem('email')
  emptyCart()
  //TODO: si erreur token expiré au /me, on refresh token -> /me
  //TODO : si le refresh token est expiré, je vide tout
  return routingFunction.push(
    `${process.env.API_DOMAIN}/ciam/logout?state=${ssoState}`
  )
}
